import React from "react";
import { LEGAL, legalIsDraft } from "./legalConfig.js";

// Small building blocks shared by the two documents.
export const H2 = ({ children }) => <h3 className="v-display text-base font-semibold mt-7 mb-2">{children}</h3>;
export const H3 = ({ children }) => <h4 className="text-sm font-semibold mt-4 mb-1.5">{children}</h4>;
export const P = ({ children }) => <p className="text-sm leading-relaxed text-ivory-dim mb-3">{children}</p>;
export const UL = ({ items }) => (
  <ul className="text-sm text-ivory-dim list-disc pl-5 space-y-1.5 mb-3 leading-relaxed">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>
);

export function DocHeader({ title, version }) {
  return (
    <div className="mb-2">
      <h2 className="v-display text-xl font-semibold">{title}</h2>
      <div className="text-xs text-ivory-dim mt-1">Last updated {LEGAL.updated} · Version {version}</div>
      {legalIsDraft() && (
        <div className="mt-3 rounded-lg px-3 py-2.5 text-xs leading-relaxed" style={{ background: "var(--brass-dim)" }}>
          Draft: some details are still in [square brackets]. Fill them in at <span className="v-mono">src/legal/legalConfig.js</span> before publishing, and have a lawyer review this document.
        </div>
      )}
    </div>
  );
}
